// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"369":"socials","725":"wechatpay","775":"bulk","825":"english","942":"socials-eng","964":"bulk-eng"}[chunkId] || chunkId) + "." + {"191":"508f20f0","369":"db0c5e17","373":"54777b26","503":"5c881169","725":"63d97a98","775":"e0dc2010","825":"8c5056e3","887":"cf562514","942":"21143c98","964":"565d6328"}[chunkId] + ".js";
};